<script>
import DibbleJS from "../../dibble";
import DibbleAPI from "../../api";

export default {
    name: "Moorage",
    data() {
        return {
            dibbleJs: DibbleJS,
            data: null,
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            DibbleJS.showLoader();
            const params = {
                request: DibbleAPI.api.getMoorageDashboard,
            };
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    this.data = responseData;
                } else {
                    DibbleJS.toastErrorMessage(responseData.message);
                }
            });
        },
        handleClick(type, url) {
            this.$router.push(`${url}/${type}`);
        },
    },
};
</script>
<template src="./template/index.html"></template>
<style scoped lang="scss">
.moorage-list {
    margin: 30px 30px;
    padding: 20px 20px;
    background: #F3F6F7;
    box-shadow: 0px 15px 20px -6px rgba(16, 24, 40, 0.15);
    border-radius: 40px;
    display: flex;
    flex-direction: column;
    min-width: 1000px;

    p {
        font-family: 'Open Sans';
        font-style: normal;
    }

    .title {
        p {
            font-weight: 600;
            font-size: 22px;
            text-transform: capitalize;
            color: #1C5169;
        }
    }

    .moorage-content {
        display: flex;
        background: #E8EFF1;
        border-radius: 40px;

        &:not(:nth-child(1)) {
            margin-top: 20px;
        }

        .moorage-info {
            width: 50%;
            padding: 10px 20px;

            .text-header {
                font-weight: 600;
                font-size: 16px;
                letter-spacing: 0.04em;
                color: #555E67;
            }

            .moorage-row {
                background: #E8EFF1;
                display: flex;
                flex-direction: column;
                border-bottom: 1.5px solid #DEE6EA;
                padding-bottom: 20px;

                &:not(:first-child) {
                    margin-top: 30px;
                }

                .title-moorange {
                    border-bottom: 1.5px solid #DEE6EA;
                    font-weight: 700;
                    font-size: 16px;
                    letter-spacing: 0.04em;
                    color: #555E67;
                    padding: 5px 0px;
                }



                .slips-column {
                    width: 50%;
                    display: flex;
                    flex-direction: column;

                    p {
                        font-size: 40px;
                        color: #555E67;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 300;
                    }
                }

                .list-available {
                    display: flex;
                    flex: 1;

                    .available-status {
                        background: #1C5169;
                        width: 132px;

                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        border-radius: 30px;
                        box-shadow: 0px 6px 10px 2px rgba(204, 204, 204, 0.63);
                        padding-bottom: 10px;

                        p {
                            color: #fff;
                        }

                        .number {
                            font-size: 40px;
                            font-weight: bold;
                        }

                        .status {
                            font-size: 16px;
                        }
                    }

                    .unavailable-status {
                        background: #C2D8DD;
                        width: 132px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        border-radius: 30px;
                        box-shadow: 0px 6px 10px 2px rgba(204, 204, 204, 0.63);
                        padding-bottom: 10px;

                        p {
                            color: #555E67;
                        }

                        .number {
                            font-size: 40px;
                            font-weight: bold;
                        }

                        .status {
                            font-size: 16px;
                        }
                    }
                }

                .income-chart {
                    flex: 1;
                    box-sizing: border-box;
                    margin-top: 1rem;
                }
            }

            .moorage-table {
                .text-income {
                    font-size: 16px;
                    color: #2C94AB;
                    font-weight: 600;
                    text-align: right;
                }

                .text-date {
                    font-weight: 400;
                    font-size: 16px;
                    letter-spacing: 0.04em;
                    color: #555E67;
                }

                table {
                    width: 80%;

                    tr {
                        td {
                            padding-bottom: 10px;
                            padding-top: 10px;
                        }
                    }
                }
            }

        }

        .moorage-img {
            flex: 1;
            background-position: center;
            background-size: cover;
            height: 350px;
            border-top-right-radius: 40px;
            border-bottom-right-radius: 40px;
            display: flex;
            justify-content: center;

            .toggle-button {
                width: 220px;
                background: #D9D9D9;
                display: flex;
                justify-content: space-between;
                margin-top: 20px;

                opacity: 0.8;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 30px;
                height: 60px;

                >div {
                    width: calc(100%/3);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-sizing: border-box;

                    &:not(:last-child) {
                        border-right: 1.5px solid #fff;
                    }

                }

                p {
                    font-weight: 600;
                    font-size: 18px;
                    color: #7C7C7A;
                }

                .active-button {
                    background: #D9D9D9 !important;
                    color: #2C94AB;
                }
            }
        }

    }


}
</style>
